import { PartnerFinances } from 'types/state';

export function createPartnerFinances(): PartnerFinances {
  return {
    balanceAmount: 0,
    earnedAmount: 0,
    paidAmount: 0,
  };
}
